<template>
  <span v-if="useHtml" class="date-format" v-html="formatted"></span>
  <span v-else class="date-format">{{formatted}}</span>
</template>

<script>
export default {
	name: "DateFormat",
	props: {
		date: {
			type: [Date, String]
		},
		format: {
			type: String,
			default: "%Y-%m-%d %H:%i:%s"
		},
		useHtml: {
			type: Boolean,
			default: false
		}
	},
	computed: {
    formatted() {
      return this.formatDate(this.date, this.format)
    }
  },
	methods: {
		formatDate(date, format) {
			date = new Date(date)
			if (date.toString() === "Invalid Date" || isNaN(date.getTime()))
				return ""
			var months = [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December"
			]
			var days = [
				"Sunday",
				"Monday",
				"Tuesday",
				"Wednesday",
				"Thursday",
				"Friday",
				"Saturday"
			]
			var month = date.getMonth() + 1
			month = (month < 10 ? "0" : "") + month
			var day = date.getDate()
			day = (day < 10 ? "0" : "") + day
			var h = date.getHours()
			var hours = (h < 10 ? "0" : "") + h
			var min = date.getMinutes()
			min = (min < 10 ? "0" : "") + min
			var seconds = date.getSeconds()
			seconds = (seconds < 10 ? "0" : "") + seconds
			format = format || "Y-m-d H:i:s"
			return format.replace(/%([a-zA-Z0-9]+)/g, function(m, v) {
				switch (v) {
					case "y":
						return `${date.getFullYear()}`.substr(2)
					case "Y":
						return date.getFullYear()
					case "m":
						return month
					case "lm":
						return months[date.getMonth()].substr(0, 3)
					case "Lm":
						return months[date.getMonth()]
					case "d":
						return day
					case "ld":
						return days[date.getDay()].substr(0, 3)
					case "Ld":
						return days[date.getDay()]
					case "h":
						return h > 12 ? h - 12 : h
					case "H":
						return hours
					case "i":
						return min
					case "s":
						return seconds
					case "a":
						return h >= 12 ? "p.m." : "a.m."
					default:
						return ""
				}
			})
		}
	}
}
</script>
